import React, {useState, useEffect} from 'react';
import {View, Platform} from 'react-native';

import {OverlaySpinner} from '@components/atoms/OverlaySpinner';
import {style} from './LoadingScreen.style';

type LoadingScreenType = {
  isLoading: boolean;
  children: React.ReactNode;
  loadingComponent?: React.ReactNode;
  delay?: number;
  renderInTheBackground?: boolean;
};

const IS_WEB = Platform.OS === 'web';

export const LoadingScreen: React.FC<LoadingScreenType> = ({
  isLoading: isComponentLoading,
  children,
  loadingComponent = <OverlaySpinner />,
  delay = 0,
  renderInTheBackground = false,
}) => {
  const [isLoading, setIsLoading] = useState(isComponentLoading);

  useEffect(() => {
    if (isComponentLoading) {
      setIsLoading(true);
      return;
    }
    // this delay is to optionally avoid flickering effect due fast rerenders
    const timer = setTimeout(() => setIsLoading(false), delay);
    return () => clearTimeout(timer);
  }, [delay, isComponentLoading]);

  if (renderInTheBackground) {
    const loadingStyle = IS_WEB ? style.loadingWeb : style.loadingNative;

    return (
      <>
        {Boolean(isLoading) && loadingComponent}
        <View style={[isLoading && loadingStyle]}>{children}</View>
      </>
    );
  }

  return <>{isLoading ? loadingComponent : children}</>;
};
